import React from "react";
import { Link } from "react-router";
import Layout from "../../components/themes/limupa/layouts/default-layout";
import { ROUTES } from "../../routes";

function NotFound(): React.JSX.Element {
  return (
    <Layout page={{ title: "404", description: "Page not found" }}>
      <h1>Page Not Found</h1>
      <p>The page you are looking for was not foung</p>
      <Link to={ROUTES.HOME}>Back to home</Link>
    </Layout>
  );
};

export default NotFound;
